export default __webpack_public_path__ + "./images/litresLogo.88c0d7a9.svg";